import { Point } from '../../_common/client/point';
import ViewportTransform from './viewport-transform';

class ViewportPhysics {
    private static readonly FRICTION = 8;
    private readonly viewportTransform: ViewportTransform;
    private velocity = Point.ORIGIN;
    private enabled = false;
    private lastMovedTime = Date.now();

    constructor(viewportTransform: ViewportTransform) {
        this.viewportTransform = viewportTransform;
    }

    public setEnabled(enabled: boolean) {
        this.enabled = enabled;
        if (!enabled) this.velocity = Point.ORIGIN;
    }

    public tick(step: number) {
        if (this.enabled) {
            const delta = this.velocity.scale(step);
            this.viewportTransform.translateBy(delta);
        }

        if (this.velocity.x !== 0 || this.velocity.y !== 0) {
            const acceleration = this.velocity.scale(-ViewportPhysics.FRICTION / 1000);
            this.velocity = this.velocity.add(acceleration.scale(step));
        }
    }

    public moveBy(delta: Point) {
        const now = Date.now();
        const deltaT = now - this.lastMovedTime;
        this.velocity = delta.scale(1 / deltaT);
        if (!this.enabled) this.viewportTransform.translateBy(delta);
        this.lastMovedTime = now;
    }

    public resetTimer() {
        this.lastMovedTime = Date.now();
    }
}

export default ViewportPhysics;
